module.exports = __webpack_public_path__ + "img/man_3_1.ad979ff8.png";